"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.formatDate = exports.formatDateYearFirst = exports.SUPPORTED_DATE_FORMATS = void 0;

var _RawTextField = _interopRequireDefault(require("./components/RawTextField"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _lodash = _interopRequireDefault(require("lodash.omit"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SUPPORTED_DATE_FORMATS = {
  en_US: 'MM/DD/YYYY',
  en_AU: 'DD/MM/YYYY',
  ja_JP: 'YYYY/MM/DD'
};
exports.SUPPORTED_DATE_FORMATS = SUPPORTED_DATE_FORMATS;
var INVALID_CHARS_REGEX = /[^0-9/]/g;

var removeInvalidChars = function removeInvalidChars(value) {
  return value.replace(INVALID_CHARS_REGEX, '');
};

var MONTH_ONLY_REGEX = /^([0-9]{1,2})(\/?)$/;
var MONTH_AND_DAY_REGEX = /^([0-9]{1,2})\/?([0-9]{1,2})(\/?)$/;
var FULL_DATE_REGEX = /^([0-9]{1,2})\/([0-9]{1,2})\/?([0-9]{1,4})/;

var dateToValue = function dateToValue(date) {
  var dd = date.getUTCDate().toString().padStart(2, '0');
  var mm = (date.getUTCMonth() + 1).toString().padStart(2, '0');
  var yyyy = date.getUTCFullYear();
  return "".concat(mm, "/").concat(dd, "/").concat(yyyy);
};

var YEAR_ONLY_REGEX = /^([0-9]{1,4})(\/?)$/;
var YEAR_AND_MONTH_REGEX = /^([0-9]{1,4})\/?([0-9]{1,2})(\/?)$/;
var FULL_DATE_YEAR_LEADING_REGEX = /^([0-9]{1,4})\/([0-9]{1,2})\/?([0-9]{1,2})/; //Custom Date Formatter in the case of YYYY/MM/DD dates

var formatDateYearFirst = function formatDateYearFirst(value) {
  var numbers = removeInvalidChars(value);

  if (YEAR_ONLY_REGEX.test(numbers)) {
    var match = YEAR_ONLY_REGEX.exec(numbers);
    var year = match[1];
    var endSlash = match[2];
    return "".concat(year).concat(endSlash);
  } else if (YEAR_AND_MONTH_REGEX.test(numbers)) {
    var _match = YEAR_AND_MONTH_REGEX.exec(numbers);

    var _year = _match[1];
    var month = _match[2];
    var _endSlash = _match[3];
    return "".concat(_year, "/").concat(_endSlash && month.length !== 2 ? "0".concat(month) : month).concat(_endSlash);
  } else if (FULL_DATE_YEAR_LEADING_REGEX.test(numbers)) {
    var _match2 = FULL_DATE_YEAR_LEADING_REGEX.exec(numbers);

    var _year2 = _match2[1];
    var _month = _match2[2];
    var day = _match2[3];
    return "".concat(_year2, "/").concat(_month.length === 2 ? _month : "0".concat(_month), "/").concat(day);
  }

  return numbers;
};

exports.formatDateYearFirst = formatDateYearFirst;

var formatDate = function formatDate(value, dateFormat) {
  dateFormat = dateFormat || SUPPORTED_DATE_FORMATS.en_US;

  if (value instanceof Date) {
    // eslint-disable-next-line no-console
    console.warn("Warning! We notice that you're setting `value` as a Date object. If you're setting value in state, your end user could run into issues when typing out a date. We recommend setting `value` as a string, and using the fourth Date object parameter returned in `onChange` for your Date-dependent change handler.");
    return dateToValue(value);
  }

  if (dateFormat === SUPPORTED_DATE_FORMATS.ja_JP) {
    return formatDateYearFirst(value);
  }

  var numbers = removeInvalidChars(value);

  if (MONTH_ONLY_REGEX.test(numbers)) {
    var match = MONTH_ONLY_REGEX.exec(numbers);
    var month = match[1];
    var endSlash = match[2];
    return "".concat(endSlash && month.length !== 2 ? "0".concat(month) : month).concat(endSlash);
  } else if (MONTH_AND_DAY_REGEX.test(numbers)) {
    var _match3 = MONTH_AND_DAY_REGEX.exec(numbers);

    var _month2 = _match3[1];
    var day = _match3[2];
    var _endSlash2 = _match3[3];
    return "".concat(_month2.length === 2 ? _month2 : "0".concat(_month2), "/").concat(_endSlash2 && day.length !== 2 ? "0".concat(day) : day).concat(_endSlash2);
  } else if (FULL_DATE_REGEX.test(numbers)) {
    var _match4 = FULL_DATE_REGEX.exec(numbers);

    var _month3 = _match4[1];
    var _day = _match4[2];
    var year = _match4[3];
    return "".concat(_month3.length === 2 ? _month3 : "0".concat(_month3), "/").concat(_day.length === 2 ? _day : "0".concat(_day), "/").concat(year);
  } else if (!!Date.parse(value)) {
    return dateToValue(new Date(value));
  }

  return numbers;
};

exports.formatDate = formatDate;

var DateField = function DateField(props) {
  return /*#__PURE__*/_react["default"].createElement(_RawTextField["default"], _extends({}, props, {
    type: "text",
    value: formatDate(props.value, props.dateFormat),
    onChange: function onChange(value, event) {
      var stringDate = formatDate(value, props.dateFormat);
      var dateValue;

      if ( // 8 or 10 digit length to allow for two-digit years
      // Example: `01/01/2010` and `01/01/10` would both work
      (stringDate.length === 8 || stringDate.length === 10) && !isNaN(Date.parse(stringDate))) {
        dateValue = new Date(stringDate);
      }

      props.onChange(stringDate, value, event, dateValue);
    },
    maxLength: 10 // 12/45/7890
    ,
    pattern: "[0-9]*"
  }));
};

DateField.Sizes = _RawTextField["default"].Sizes;
DateField.propTypes = _objectSpread(_objectSpread({}, (0, _lodash["default"])(_RawTextField["default"].propTypes, ['type', 'isMultiline'])), {}, {
  dateFormat: _propTypes["default"].oneOf(Object.values(SUPPORTED_DATE_FORMATS))
});
DateField.defaultProps = _objectSpread(_objectSpread({}, _RawTextField["default"].defaultProps), {}, {
  dateFormat: SUPPORTED_DATE_FORMATS.en_US
});
var _default = DateField;
exports["default"] = _default;